import { useCheckPermissions, PERMISSIONS } from "../../../../../Auth"
import { Navigate, Path } from "../../../../../router-utils"

export default function OrganizationSupplierPaymentPreferencesPage() {
	const { hasPermission } = useCheckPermissions()

	const hasHotel = hasPermission(PERMISSIONS.VIEW_HOTEL_SUPPLIERS)
	const hasTransport = hasPermission(
		PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS
	)

	// No permissions: send to a neutral page, e.g. back to org root,
	let redirectTo: Path = "/org"

	if (hasHotel) {
		// If user has both
		// prioritize hotel, then transport
		redirectTo = "/org/supplier-payment-preferences/hotel"
	} else if (hasTransport) {
		redirectTo = "/org/supplier-payment-preferences/transport"
	}

	return <Navigate to={redirectTo} replace />
}
